import SvgIcon from './SvgIcon';
import LoadingDots from './LoadingDots';
import DownRectFill from './DownRectFill';
import DocumentSearch from './DocumentSearch';
var Svg = SvgIcon;
Svg.LoadingDots = LoadingDots;
Svg.DownRectFill = DownRectFill;
Svg.DocumentSearch = DocumentSearch;
export default Svg;
